var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1463_242)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.75 5.00007C8.75001 4.21652 8.50459 3.45264 8.04819 2.81573C7.59179 2.17882 6.94735 1.70087 6.20538 1.44901C5.46341 1.19715 4.66119 1.18403 3.91138 1.41149C3.16157 1.63896 2.50184 2.09558 2.02486 2.71723C1.54788 3.33887 1.27761 4.09431 1.252 4.87745C1.2264 5.66058 1.44674 6.43206 1.88209 7.08354C2.31744 7.73502 2.94593 8.23377 3.67928 8.50973C4.41263 8.78569 5.214 8.825 5.97083 8.62215",
    stroke: "#A53DFF",
    strokeWidth: 0.833333,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.00004 6.66634C5.92052 6.66634 6.66671 5.92015 6.66671 4.99967C6.66671 4.0792 5.92052 3.33301 5.00004 3.33301C4.07957 3.33301 3.33337 4.0792 3.33337 4.99967C3.33337 5.92015 4.07957 6.66634 5.00004 6.66634Z",
    stroke: "#A53DFF",
    strokeWidth: 0.833333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66663 3.75V5.625C6.66663 5.90127 6.77637 6.16622 6.97172 6.36157C7.16707 6.55692 7.43203 6.66667 7.70829 6.66667C7.98456 6.66667 8.24951 6.55692 8.44486 6.36157C8.64021 6.16622 8.74996 5.90127 8.74996 5.625V5",
    stroke: "#A53DFF",
    strokeWidth: 0.833333,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1463_242"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.12f7df2936621d709df7b75e16d119cc.svg";
export { ForwardRef as ReactComponent };